export const getBrowser = () => {
  if (navigator.userAgent.match('CriOS')) {
    return 'CriOS';
  }

  if (
    (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
    !(window as any).MSStream
  ) {
    return 'iOS';
  }

  if (/(android)/i.test(navigator.userAgent)) {
    return 'Android';
  }

  if (
    (navigator.userAgent.indexOf('Opera') ||
      navigator.userAgent.indexOf('OPR')) != -1
  ) {
    return 'Opera';
  }

  if (navigator.userAgent.indexOf('Edg') != -1) {
    return 'Edge';
  }

  if (navigator.userAgent.indexOf('Chrome') != -1) {
    return 'Chrome';
  }

  if (navigator.userAgent.indexOf('Safari') != -1) {
    return 'Safari';
  }

  if (navigator.userAgent.indexOf('Firefox') != -1) {
    return 'Firefox';
  }

  if (
    navigator.userAgent.indexOf('MSIE') != -1 ||
    !!(document as any).documentMode
  ) {
    return 'IE';
  }

  return 'unknown';
};
